import React, { createContext, useContext, useState } from "react";
import { saveEnrollment } from "_graphql/mutations";
import { getLead } from "_graphql/queries";
import { message } from "@centrate-io/barn";
import queryString from "query-string";
const LeadContext = createContext();

// Create a provider component
export const LeadProvider = ({ children, client }) => {
  const [lead, setLead] = useState(undefined);
  const [savedPlan, setSavedPlan] = useState(undefined);
  const [bank, setBank] = useState(undefined);
  const [plaid, setPlaid] = useState(undefined);
  const [audit, setAudit] = useState(undefined);
  const [currentStep, setCurrentStep] = useState(undefined);
  const [portalUrl, setPortalUrl] = useState(undefined);

  // Load Payments
  const fetchLead = async () => {
    const params = queryString.parse(window.location.search);
    if (!localStorage.getItem("pp_lead") || params?.preview === "paypath") {
      setLead({});
    } else {
      const leadData = await client.query({
        variables: {
          id: localStorage.getItem("pp_lead"),
          company_id: localStorage.getItem('pp_company_id') || process.env.REACT_APP_COMPANY_ID,
        },
        query: getLead,
      });
      let app = leadData?.data?.getLead;
      const planData = app?.plan?.saved_plan || null;
      const bankData = app?.bank || null;
      const plaidData = app?.plaid || null;
      const auditData = app?.audit || null;
      const currentStepData = app?.current_step || null;
      const portalUrlData = app?.portal_url || null;
      if (!app) {
        message.error("Application not found");
        localStorage.removeItem("pp_lead");
        localStorage.removeItem("pp_qualify");
        return;
      }
      if (app.first_name === "Self" && app.last_name === "Enrollment") {
        delete app.first_name;
        delete app.last_name;
      }
      if (app.plan && 'saved_plan' in app.plan) {
        delete app.plan.saved_plan;
      }
      if ('bank' in app) {
        delete app.bank;
      }
      if ('plaid' in app) {
        delete app.plaid;
      }
      if ('audit' in app) {
        delete app.audit;
      }
      // Remove current_step as it's a computed field from SelfEnrollmentStat,
      // not part of ApplicationInput
      if ('current_step' in app) {
        delete app.current_step;
      }
      // Remove portal_url as it's a computed field, not part of ApplicationInput
      if ('portal_url' in app) {
        delete app.portal_url;
      }
      setBank(bankData);
      setSavedPlan(planData);
      setPlaid(plaidData);
      setAudit(auditData);
      setCurrentStep(currentStepData);
      setPortalUrl(portalUrlData);
      setLead(app);
    }
  };

  const updateLead = (f, v) => {
    const n = { ...lead };
    n[f] = v;
    setLead(n);
  };

  const updateAddress = (values) => {
    setLead({ ...lead, ...values });
  };

  const saveLead = async (overrides = {}, recaptchaToken = null) => {
    let formResult = null;
    try {
      const formData = { first_name: "Self", last_name: "Enrollment", ...lead, ...overrides };
      if (localStorage.getItem("pp_lead")) {
        formData.id = localStorage.getItem("pp_lead");
      }
      const variables = {
        application: formData,
        company_id: localStorage.getItem('pp_company_id') || process.env.REACT_APP_COMPANY_ID,
      };
      // Only include recaptcha_token if provided
      if (recaptchaToken) {
        variables.recaptcha_token = recaptchaToken;
      }
      formResult = await client.mutate({
        variables,
        mutation: saveEnrollment,
      });
      fetchLead();
    } catch (err) {
      formResult = null;
      console.log(err);
    }
    return formResult?.data?.saveEnrollment || null;
  };

  // useEffect(() => {
  //   fetchLead();
  // }, []);

  return (
    <LeadContext.Provider
      value={{
        lead,
        reload: fetchLead,
        savedPlan,
        bank,
        plaid,
        audit,
        currentStep,
        portalUrl,
        saveLead,
        updateLead,
        updateAddress,
      }}
    >
      {children}
    </LeadContext.Provider>
  );
};

// Custom hook to use the context
export const useLead = () => {
  return useContext(LeadContext);
};
